"use client";
import React from "react";
import { generateStockUrl } from '@/utils/stocksUrls';

interface StocksPageSchemaMarkupProps {
  stocks: any[];
}

export default function StocksPageSchemaMarkup({ stocks }: StocksPageSchemaMarkupProps) {
  // Helper to generate absolute stock URL
  function getAbsoluteStockUrl(stock: any) {
    return `https://www.solflare.com${generateStockUrl(stock)}`;
  }

  // Get current timestamp for dateModified
  const currentDate = new Date().toISOString();

  // Generate ItemList elements from stocks (first 90)
  const itemListElements = stocks.slice(0, 90).map((stock, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    url: getAbsoluteStockUrl(stock)
  }));

  return (
    <>
      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Buy Tokenized Stocks with Crypto | Trade Stocks On-Chain',
            url: 'https://www.solflare.com/stocks/',
            description: 'Trade tokenized stocks like Tesla, SP500, and NVIDIA directly from your Solflare wallet using USDC or SOL. No brokers, no delays, 24/7 access through Solana.',
            inLanguage: 'en',
            datePublished: '2025-07-25T00:00:00Z',
            dateModified: currentDate
          })
        }}
      />

      {/* ItemList Schema */}
      <script
        type="application/ld+json"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: 'Top Tokenized Stocks',
            itemListElement: itemListElements
          })
        }}
      />
    </>
  );
} 